import { z } from "zod";

export const UserSchema = z.object({
  id: z.string(),
  workosId: z.string(),
  email: z.string().email(),
  name: z.string().nullable(),
  avatarUrl: z.string().url().nullable(),
  createdAt: z.string().datetime(),
  needsDisplayName: z.boolean().optional(),
});

export type User = z.infer<typeof UserSchema>;

export const SyncUserSchema = z.object({
  workosId: z.string(),
  email: z.string().email(),
  name: z.string().nullable().optional(),
  avatarUrl: z.string().url().nullable().optional(),
});

export type SyncUserInput = z.infer<typeof SyncUserSchema>;

export const UpdateProfileSchema = z.object({
  name: z.string().trim().min(1).max(100),
});

export type UpdateProfileInput = z.infer<typeof UpdateProfileSchema>;

/** Client-registered Expo push token, or null to clear. */
export const UpdateExpoPushTokenSchema = z.object({
  expoPushToken: z.string().min(1).max(512).nullable(),
});

export type UpdateExpoPushTokenInput = z.infer<
  typeof UpdateExpoPushTokenSchema
>;

const AVATAR_CONTENT_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/heic",
] as const;

export const RequestAvatarUploadUrlSchema = z.object({
  contentType: z.enum(AVATAR_CONTENT_TYPES),
});

export type RequestAvatarUploadUrlInput = z.infer<
  typeof RequestAvatarUploadUrlSchema
>;

export const ConfirmAvatarUploadSchema = z.object({
  storageKey: z.string().min(1).max(512),
});

export type ConfirmAvatarUploadInput = z.infer<
  typeof ConfirmAvatarUploadSchema
>;
